<script setup lang="ts">
import FormPlano from '../components/form-plano.vue'
import { usePlanoStore } from '../store/usePlanoStore'

definePage({
  meta: {
    navActiveLink: 'admin-plano',
    action: 'create',
    subject: 'plano',
  },
})

const { resetForm } = usePlanoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormPlano />
</template>
